module.exports = __webpack_public_path__ + "media/images/official-5-85919ec8a34a732a17243a387b364482.png";